import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import Axios from "axios";
import { toast, ToastContainer } from "react-toastify";

const tagStyle = {
  fontFamily: "Nunito", fontSize: 12, fontWeight: 700, color: "#374151",
  background: "#f3f4f6", borderRadius: 20, padding: "4px 12px", whiteSpace: "nowrap",
};

const infoRow = { display: "flex", alignItems: "flex-start", gap: 10, padding: "10px 0", borderBottom: "1px solid #f3f4f6" };
const labelStyle = { fontFamily: "Nunito", fontSize: 12, fontWeight: 700, color: "#9ca3af", minWidth: 100, marginTop: 2 };
const valueStyle = { fontFamily: "Nunito", fontSize: 14, color: "#111827", flex: 1, wordBreak: "break-word" };

const InvestorPage = () => {
  const location = useLocation();
  const history = useNavigate();
  const { investor } = location.state;
  const [verified, setVerify] = useState(false);
  const [declined, setDecline] = useState(false);
  const [document, setdocument] = useState();
  const [review, setreview] = useState("");

  const handleVerify = async () => {
    if (!confirm("Are you sure you want to Verify this?")) return;
    await Axios.post("/api/admin/handle-investors/accept", investor)
      .then(() => { toast.success("Successfully Verified"); setVerify(true); })
      .catch(() => { toast.error("Some Error"); setVerify(false); });
  };

  const handleDecline = async () => {
    if (!confirm("Are you sure you want to Decline this?")) return;
    await Axios.post("/api/admin/handle-investors/decline", investor)
      .then(() => { toast.warning("Successfully Declined"); setDecline(true); setTimeout(() => history("/admin/verify-investor"), 500); })
      .catch(() => { toast.error("Some Error"); setDecline(false); });
  };

  const fetchDocument = async () => {
    await Axios({ method: "GET", url: `/api/admin/documents/${investor.id}` })
      .then((res) => setdocument(res.data))
      .catch(() => {});
  };

  useEffect(() => { fetchDocument(); }, []);

  const sendReview = async () => {
    if (!confirm("Are you sure you want to Send this review?")) return;
    await Axios.post("/api/admin/review", { id: investor.id, reason: review })
      .then(() => toast.success("Successfully Sent Review"))
      .catch(() => toast.error("Some error"));
  };

  return (
    <div style={{ padding: "36px 40px", maxWidth: 960, margin: "0 auto", boxSizing: "border-box" }}>
      {/* Header */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "28px 32px", marginBottom: 24, display: "flex", alignItems: "flex-start", gap: 24 }}>
        <Avatar src={investor.profilePic} style={{ width: 80, height: 80, border: "1px solid #e5e7eb", flexShrink: 0, fontSize: 28 }} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <h1 style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 28, color: "#111827", margin: "0 0 4px" }}>{investor.name}</h1>
          <p style={{ fontFamily: "Nunito", fontSize: 14, color: "#6b7280", margin: "0 0 12px" }}>{investor.location?.country}</p>
          {investor.interestedDomains?.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {investor.interestedDomains.map((d, i) => <span key={i} style={tagStyle}>{d}</span>)}
            </div>
          )}
        </div>
      </div>

      {/* Two-column body */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 340px", gap: 20, alignItems: "start" }}>
        {/* Left: details + Verify/Decline */}
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "20px 24px" }}>
            <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 13, color: "#374151", margin: "0 0 10px", textTransform: "uppercase", letterSpacing: 1 }}>Contact Details</p>
            <div style={infoRow}><span style={labelStyle}>Email</span><span style={valueStyle}>{investor.contact?.email}</span></div>
            <div style={infoRow}>
              <span style={labelStyle}>LinkedIn</span>
              {investor.socialConnects?.linkedProfile
                ? <a href={investor.socialConnects.linkedProfile} target="_blank" rel="noreferrer" style={{ ...valueStyle, color: "#3b82f6", textDecoration: "underline", wordBreak: "break-all" }}>{investor.socialConnects.linkedProfile}</a>
                : <span style={valueStyle}>—</span>}
            </div>
            <div style={infoRow}><span style={labelStyle}>Location</span><span style={valueStyle}>{investor.location?.country}</span></div>
            <div style={infoRow}>
              <span style={labelStyle}>Invested</span>
              <span style={valueStyle}>{investor.investedValue || "—"}</span>
            </div>
            {/* Verify / Decline inside contact card */}
            <div style={{ display: "flex", gap: 10, marginTop: 20, paddingTop: 16, borderTop: "1px solid #f3f4f6" }}>
              <button
                onClick={declined ? undefined : handleDecline}
                style={{ flex: 1, fontFamily: "Nunito", fontSize: 13, fontWeight: 700, background: "#fff", color: declined ? "#9ca3af" : "#dc2626", border: `1px solid ${declined ? "#e5e7eb" : "#dc2626"}`, borderRadius: 8, padding: "10px", cursor: declined ? "default" : "pointer" }}>
                {declined ? "Declined" : "Decline"}
              </button>
              <button
                onClick={verified ? undefined : handleVerify}
                style={{ flex: 1, fontFamily: "Nunito", fontSize: 13, fontWeight: 700, background: verified ? "#e5e7eb" : "#111827", color: verified ? "#9ca3af" : "#fff", border: "none", borderRadius: 8, padding: "10px", cursor: verified ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                <DoneAllIcon style={{ fontSize: 16 }} />
                {verified ? "Verified" : "Verify"}
              </button>
            </div>
          </div>

          {document?.documents?.photoid && (
            <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "20px 24px" }}>
              <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 13, color: "#374151", margin: "0 0 12px", textTransform: "uppercase", letterSpacing: 1 }}>Identity</p>
              <a href={document.documents.photoid} target="_blank" rel="noreferrer"
                style={{ display: "block", fontFamily: "Nunito", fontSize: 13, fontWeight: 700, color: "#111827", background: "#f3f4f6", borderRadius: 8, padding: "10px 14px", textDecoration: "none", border: "1px solid #e5e7eb" }}>
                Photo ID →
              </a>
            </div>
          )}
        </div>

        {/* Right: placeholder for future content */}
        <div />
      </div>

      {/* Send Review — full width below */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "24px 28px", marginTop: 20 }}>
        <p style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 13, color: "#374151", margin: "0 0 12px", textTransform: "uppercase", letterSpacing: 1 }}>Send Review</p>
        <textarea
          rows={5}
          placeholder="Write feedback for the investor…"
          onChange={(e) => setreview(e.target.value)}
          value={review}
          style={{ width: "100%", boxSizing: "border-box", fontFamily: "Nunito", fontSize: 14, color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8, padding: "12px 14px", resize: "vertical", outline: "none", lineHeight: 1.6 }}
        />
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
          <button onClick={sendReview}
            style={{ fontFamily: "Nunito", fontSize: 13, fontWeight: 700, background: "#111827", color: "#fff", border: "none", borderRadius: 8, padding: "10px 28px", cursor: "pointer" }}>
            Send Review
          </button>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default InvestorPage;
